const PERMISSION_KEY= "personalize:nebula_profile";
const PAGE_URL = {
    NEBULA_PROFILE_PAGE: "/admin/personalize/nebula-profile"
}

export {PERMISSION_KEY, PAGE_URL}

